import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/FetchPaymentAccountSummary";

export function* fetchPaymentAccountSummary(action: Actions.FetchPaymentAccountSummaryAction) {
    const { payload } = action;
    const { credentials, organizationId } = payload;
    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const summary = yield api.getPaymentAccountSummary(organizationId);
        yield put(Actions.fetchPaymentAccountSummaryEnd(undefined, organizationId, summary));
    } catch (e) {
        const data = e.data || {};
        if (data.httpStatus === 404) {
            // account not found
            yield put(Actions.fetchPaymentAccountSummaryEnd(undefined, organizationId, {}));
        } else {
            yield put(addNotification(e.message, true));
            yield put(Actions.fetchPaymentAccountSummaryEnd(e, organizationId));
        }
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchPaymentAccountSummary() {
    yield takeEvery(Actions.FETCH_PAYMENT_ACCOUNT_SUMMARY, fetchPaymentAccountSummary);
}
